import { ModelBase } from './model-base';

export class PagedResult<TModel extends ModelBase> {
  items: TModel[];
  page: number;
  pageCount: number;
  pageSize: number;
  totalResults: number;
}
